/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-12-04 10:15:45
 *
 *******************************************************/

import React from 'react';
import { TextStyle } from '@shopify/polaris';

function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(
  //$FlowFixMe
  require.context('../assets/images/install/slideshow', false, /\.(png|jpe?g|svg)$/)
);

const imageLoader = i18n => {
  return [
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader1_Title'),
      src: images[0]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader2_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader2_Content1')}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader2_Content2', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader2_Content2_t1')}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader2_Content2_t2')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[Object.keys(images)[0]]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader3_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader3_Content1')}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader3_Content2', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader3_Content2_t1')}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader3_Content2_t2')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[2]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader4_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader4_Content1')}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader4_Content2', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader4_Content2_t')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[3]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader5_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader5_Content1', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader5_Content1_t')}
                </TextStyle>
              )
            })}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader5_Content2', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader5_Content2_t')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[4]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader6_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader6_Content1', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader6_Content1_t1')}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader6_Content1_t2')}
                </TextStyle>
              )
            })}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader6_Content2')}
          </span>
        </span>
      ),
      src: images[5]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader7_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader7_Content1', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader7_Content1_t')}
                </TextStyle>
              )
            })}
          </span>

          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader7_Content2', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader7_Content2_t')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[6]
    },
    {
      title: i18n.translate('AdminHTML.Installation.Constant.imageLoader8_Title'),
      content: (
        <span>
          <span className="content-line">
            {i18n.translate('AdminHTML.Installation.Constant.imageLoader8_Content1', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader8_Content1_t1')}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Installation.Constant.imageLoader8_Content1_t2')}
                </TextStyle>
              )
            })}
          </span>
        </span>
      ),
      src: images[7]
    }
  ];
};

export default imageLoader;
